<template>
  <div id="container">
    <div class="content">
      <div class="product-status">
        <div class="bold"></div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            :label="item.title"
            :name="item.name"
            class="tab-text"
            v-for="item in productBrandList"
            :key="item.name"
          ></el-tab-pane>
        </el-tabs>
        <div class="search-style" v-show="activeName !== 'operationLog'">
          <el-form>
            <el-row :gutter="20">
              <el-col :span="4" style="padding-left:0px !important">
                <el-form-item v-show="activeName==='brandManage'">
                  <el-select
                    v-model="params.column"
                    placeholder="全部"
                    @change="onChangeBrand(params.column)"
                  >
                    <el-option label="品牌名称" value="brandName"></el-option>
                    <el-option label="品牌别称" value="brandNickname"></el-option>
                    <el-option label="是否推荐" value="isRecomend"></el-option>
                    <el-option label="状态" value="flag"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item v-show="activeName==='seriesManage'">
                  <el-select v-model="params.column" placeholder="全部">
                    <el-option label="品牌" value="brandName"></el-option>
                    <!-- <el-option label="系列组名称" value="serialGroupName"></el-option> -->
                    <el-option label="系列名称" value="serialName"></el-option>
                    <el-option label="系列别称" value="serialNickName"></el-option>
                    <el-option label="状态" value="flag"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-input
                    v-show="params.column==='brandName'||params.column==='serialName'||params.column==='brandNickname'||params.column===''||params.column==='serialNickName'"
                    v-model="params.value"
                    placeholder="请输入关键词"
                  ></el-input>
                  <el-select v-model="params.value" v-show="params.column==='flag'">
                    <el-option label="启用" :value="1"></el-option>
                    <el-option label="停用" :value="0"></el-option>
                  </el-select>
                  <el-select v-model="params.value" v-show="params.column==='isRecomend'">
                    <el-option label="已推荐" :value="1"></el-option>
                    <el-option label="未推荐" :value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="14">
                <el-col :span="12">
                  <el-button @click="onSearch" type="primary">搜索</el-button>
                  <el-button @click="onSearchReset" type>重置</el-button>
                </el-col>
                <el-col :span="12" style="text-align:right;">
                  <el-button
                    type="primary"
                    plain
                    @click="onAddBrand(1)"
                    v-show="activeName === 'brandManage'"
                  >添加品牌</el-button>
                  <el-button
                    type="primary"
                    plain
                    @click="addBrandSeries(1)"
                    v-show="activeName === 'seriesManage'"
                  >添加系列</el-button>
                  <!-- <el-button
                    type="primary"
                    plain
                    @click="updateBrandSeries"
                    v-show="activeName === 'seriesManage'"
                  >设置系列组</el-button>-->
                </el-col>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <!-------------- 品牌管理列表 -------------->
        <brand-table
          @onRefresh="getList"
          :tab-active="activeName"
          :brandTable="brandTable"
          :loadingBrandTable="loadingBrandTable"
          v-show="activeName === 'brandManage'"
        ></brand-table>
        <!-------------- 系列管理列表 -------------->
        <brand-series-table
          ref="brandSeriesTableRefs"
          @onRefresh="getList"
          :seriesTable="seriesTable"
          :loadingSeriesTable="loadingSeriesTable"
          :tab-active="activeName"
          v-show="activeName === 'seriesManage'"
        ></brand-series-table>
        <!-------------- 操作日志 -------------->
        <operation-log ref="operationLogRefs" v-show="activeName === 'operationLog'"></operation-log>
        <!-------------- 分页 -------------->
        <div
          class="pagination"
          v-show="activeName === 'brandManage'||activeName === 'seriesManage'"
        >
          <pagination
            :total="total"
            :currentPage="currentPage"
            :pageSize="pageSize"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
          ></pagination>
        </div>
      </div>
    </div>
    <!-------------- 添加品牌 -------------->
    <add-or-edit-brand @onRefresh="getList" ref="addEditBrandRefs"></add-or-edit-brand>
    <!-------------- 添加系列 -------------->
    <add-or-edit-series @onRefresh="getList" ref="addBrandSeriesRefs"></add-or-edit-series>
    <!-------------- 编辑系列 -------------->
    <update-brand-series @onRefresh="getList" ref="updateBrandSeriesRefs"></update-brand-series>
  </div>
</template>

<script>
import brandTable from '../components/brand/brandTable'
import brandSeriesTable from '../components/brand/brandSeriesTable'
import operationLog from '@/components/OperationLog/tableOperationLog'
import pagination from '@/components/pagination'
import addOrEditBrand from '../dialog/addOrEditBrand'
import addOrEditSeries from '../dialog/addOrEditSeries'
import { deepClone } from '@/util'
import updateBrandSeries from '../dialog/updateBrandSeries'
import { productBrandList } from '../utils/data'
import {
  brandBaseQueryPageAll,
  brandSeriesQueryPageAll
} from '@/api/product/productManage'
export default {
  components: {
    brandTable,
    brandSeriesTable,
    operationLog,
    pagination,
    updateBrandSeries,
    'add-or-edit-series': addOrEditSeries,
    'add-or-edit-brand': addOrEditBrand
  },
  data () {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 30,

      params: {
        column: ''
      },
      paramsList: {},

      activeName: 'brandManage',
      productBrandList: [],
      brandTable: [], // 品牌管理列表
      seriesTable: [], // 系列管理列表
      loadingBrandTable: false, // 品牌列表loading
      loadingSeriesTable: false // 系列列表loading
    }
  },
  created () {
    this.productBrandList = productBrandList
    this.getList()
  },
  methods: {
    // 品牌管理,系列管理搜索
    onSearch () {
      this.paramsList = deepClone(this.params)

      if (
        this.paramsList.value === '' ||
        this.paramsList.value === undefined ||
        this.paramsList.column === ''
      ) {
        this.$message.error('搜索条件不能为空')
      } else {
        this.currentPage = 1
        this.pageSize = 30
        this.getList()
      }
    },
    onSearchReset () {
      this.params = {
        column: ''
      }
      this.time = []
      this.paramsList = {}
      this.currentPage = 1
      this.pageSize = 30
      this.getList()
    },
    // 获取品牌管理列表
    getBrandList () {
      this.loadingBrandTable = true
      const params = {
        criteriaVoList: [this.paramsList],
        queryPageName: ''
      }
      brandBaseQueryPageAll(this.currentPage, this.pageSize, params)
        .then((res) => {
          if (res.data.code === 200) {
            this.loadingBrandTable = false
            this.brandTable = res.data.obj.records
            this.total = res.data.obj.total
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 获取系列管理列表
    getSeriesList () {
      this.loadingSeriesTable = true
      const params = {
        criteriaVoList: [this.paramsList],
        queryPageName: ''
      }
      brandSeriesQueryPageAll(this.currentPage, this.pageSize, params)
        .then((res) => {
          if (res.data.code === 200) {
            this.loadingSeriesTable = false
            this.seriesTable = res.data.obj.records
            this.total = res.data.obj.total
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    handleClick (tab) {
      this.currentPage = 1
      this.activeName = tab.name
      this.onSearchReset()
    },
    // 切换tabs或者页码时判断请求哪个列表接口
    getList () {
      if (this.activeName === 'brandManage') {
        // 品牌管理列表接口
        this.getBrandList()
      } else if (this.activeName === 'seriesManage') {
        // 品牌管理列表接口
        this.getSeriesList()
      } else if (this.activeName === 'operationLog') {
        this.$refs.operationLogRefs.getList()
      }
    },
    // 添加,编辑品牌
    onAddBrand (type) {
      this.$refs.addEditBrandRefs.onInitialize(type)
    },
    // 添加系列
    addBrandSeries (type) {
      this.$refs.addBrandSeriesRefs.onInitialize(type)
    },
    // 修改系列组
    updateBrandSeries () {
      if (this.$refs.brandSeriesTableRefs.checkList < 1) {
        this.$message.warning('请选中需要修改的系列')
        return
      }
      this.$refs.updateBrandSeriesRefs.onInitialize(
        this.$refs.brandSeriesTableRefs.checkList
      )
    },
    // 切换品牌管理搜索条件清空搜索条件
    onChangeBrand (column) {
      this.params = {
        column: column,
        value: ''
      }
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val

      this.getList()
    },
    // 页数
    handleSizeChange (val) {
      this.currentPage = 1
      this.pageSize = val
      this.getList()
    }
  }
}
</script>
